import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "The Silence",
    body: "For months we have said nothing. Silence is not absence — it is preparation. Every quiet hour has been spent building what comes next.",
  },
  {
    num: "02",
    title: "The Signal",
    body: "You found this page. That is not an accident. Consider it the first frequency of a broadcast that has not fully begun.",
  },
  {
    num: "03",
    title: "The Arrival",
    body: "No dates. No categories. No leaks. When Zavico surfaces, you will not need an explanation. You will simply know.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="py-24 sm:py-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <motion.p
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={fadeUp}
      className="text-xs font-mono-z uppercase tracking-[0.4em] text-[#00f0ff] mb-16"
    >
      [ The Manifesto ]
    </motion.p>

    <div className="space-y-20 sm:space-y-28">
      {chapters.map((c, i) => (
        <motion.article
          key={c.num}
          data-testid={`manifesto-chapter-${c.num}`}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          className={`group grid grid-cols-1 md:grid-cols-12 gap-6 items-start ${i % 2 ? "md:text-right" : ""}`}
        >
          <div className={`md:col-span-3 ${i % 2 ? "md:order-2" : ""}`}>
            <span className="font-display text-6xl sm:text-8xl font-extrabold text-outline transition-colors duration-500 group-hover:[-webkit-text-stroke:1px_rgba(0,240,255,0.5)]">
              {c.num}
            </span>
          </div>
          <div className={`md:col-span-7 ${i % 2 ? "md:order-1 md:col-start-2 md:flex md:flex-col md:items-end" : ""}`}>
            <h2 className="font-display text-2xl sm:text-4xl font-bold uppercase tracking-tight mb-5">
              <span className="text-[#00f0ff] mr-3">//</span>
              {c.title}
            </h2>
            <p className="text-sm sm:text-base text-[#8e8ea0] leading-relaxed max-w-lg font-mono-z">{c.body}</p>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);

export default Manifesto;
